import React, { useState, useEffect, createContext } from 'react';
import axios from './api/axios';
import Register from './components/pages/Register';
import Login from './components/pages/Login';
import Home from './components/pages/Home';
import { ToastContainer } from 'react-toastify';
import Layout from './components/Layout';
import { toast } from 'react-toastify';
import Unauthorized from './components/Unauthorized';
import RequireAuth from './components/RequireAuth';
import { Routes, Route } from 'react-router-dom';
import ForgetPassword from './components/pages/ForgetPassword';
import ChangePassword from './components/pages/ChangePassword';
import Slidebar from './components/pages/Slidebar';
import Milestones from './components/pages/Milestones';
import Project from './components/pages/Project';
import PersonalDetail from './components/pages/PersonalDetail';
import ManageRole from './components/pages/ManageRole';
import PortalUser from './components/pages/PortalUser';
import ClientUser from './components/pages/ClientUsers';
import TaskDetail from './components/pages/TaskDetail';
import Task from './components/pages/Task';
import GanttChart from './components/pages/GanttChart';
import SerialSequence from './components/pages/SerialSequence';
import AddCompany from './components/pages/AddCompany';
import AddBusinessUnit from './components/pages/AddBusinessUnit';
import AddDepartment from './components/pages/AddDepartment';
import Faq from './components/pages/Faq';
import { InfinitySpin } from 'react-loader-spinner';
import ErrorHandle from './components/ErrorHandle';
import BulkUpload from './components/pages/BulkUpload';
import ArchiveProjects from './components/pages/ArchiveProjects';
import Bugs from './components/pages/Bugs';
import Sample from './components/pages/sample';

export const GlobalContext = createContext({});

function App() {
  const roles = localStorage.getItem('roles')&&(JSON?.parse(atob(localStorage.getItem('roles')))) || [];
  const [rolexModuleData, setRolexModuleData] = useState([]);
  const user_id = localStorage.getItem('user_id')&&parseInt(atob(localStorage.getItem('user_id'))) || '';
  const [serialSequence, setSerialSequence] = useState([]);
  const [loading, setLoading] = useState(true); // Add a loading state
  const updateState = () => {
    setLoading(false);
  };
  const [userProfile, setUserProfile] = useState({
    name: null,
    emailId: null,
    contactNumber: null,
    bu: null,
    department: null,
    profileImageUrl: null,
    firstLoginStatus: null,
  });

  // ------------------------------------------------------------ Get Multiple Roles --------------------------------
  const getMultipleRoleXModule = (roles) => {
    return new Promise((resolve, reject) => {
      const params = {
        roles: roles,
      };
      axios
        .post('/getmultipleRoleXModule', params)
        .then((response) => {
          const data = response?.data;
          localStorage?.setItem('rolexModuleData', btoa(JSON?.stringify(data)));
          resolve(data); // Resolve the promise with the fetched data
        })
        .catch((err) => {
          reject(err); // Reject the promise with an error if there's an issue
        });
    });
  };
  
  // ------------------------------------------------------------ Get Serial Sequence -------------------------------
 const getSerialSequence = () => {
    return new Promise((resolve, reject) => {
      axios
        .get('/getSerialSequence')
        .then((response) => {
          const data = response?.data;
          localStorage?.setItem('serialSequence', btoa(JSON?.stringify(data)));
          resolve(data); // Resolve the promise with the fetched data
        })
        .catch((error) => {
          reject(error); // Reject the promise with an error if there's an issue
        });
    });
  };
  

  // ------------------------------------------------------------------- Get User Profile ---------------------------------------
 const getUserProfile = () => {
    return new Promise((resolve, reject) => {
      axios
        .post('/getUserProfile', { user_id })
        .then((response) => {
          const data = {
            name: response?.data?.[0]?.user_data?.[0]?.name,
            emailId: response?.data?.[0]?.user_data?.[0]?.email_id,
            contactNumber: response?.data?.[0]?.user_data?.[0]?.contact_number,
            bu: response?.data?.[0]?.user_data?.[0]?.bu_master?.[0],
            department: response?.data?.[0]?.user_data?.[0]?.department_master?.[0],
            company: response?.data?.[0]?.user_data?.[0]?.company_master?.[0],
            profileImageUrl: response?.data?.[0]?.user_data?.[0]?.profile_image_url,
            username: response?.data?.[0]?.user_data?.[0]?.username,
            firstLoginStatus: response?.data?.[0]?.user_data?.[0]?.firstLoginStatus,
          };
          localStorage?.setItem('userProfile', btoa(JSON?.stringify(data)));
          resolve(data); // Resolve the promise with the fetched data
        })
        .catch((error) => {
          reject(error); // Reject the promise with an error if there's an issue
        });
    });
  };
  
// ------------------------------------------------------------------ useEffect -----------------------------------------------
    useEffect(() => {
      if (localStorage?.getItem("hitting")) {
        Promise.all([
          getMultipleRoleXModule(roles),
          getSerialSequence(),
          getUserProfile()
        ])?.then(([rolexModuleDataResponse, serialSequenceResponse, userProfileResponse]) => {
            localStorage?.removeItem("hitting");
            setLoading(false);
    
            // Use the resolved data as needed
            setRolexModuleData(rolexModuleDataResponse);
            setSerialSequence(serialSequenceResponse);
            setUserProfile(userProfileResponse);
          })
          .catch((error) => {
            // Handle any errors if needed
            console.error(error);
          });
      } else if (rolexModuleData) {
        setRolexModuleData(localStorage?.getItem("rolexModuleData")&&(JSON?.parse(atob(localStorage?.getItem("rolexModuleData")))) ||[]);
        setSerialSequence(localStorage?.getItem("serialSequence")&&(JSON?.parse(atob(localStorage?.getItem("serialSequence")))) ||[]);
        setUserProfile(localStorage?.getItem("userProfile")&&(JSON?.parse(atob(localStorage?.getItem("userProfile")))) ||[]);
        setLoading(false);
      }
    }, []);
    

  // const globalState = {
  //   roles,
  //   rolexModuleData,
  //   user_id,
  //   serialSequence,
  //   userProfile,
  // };

  /** Mapping Components For Routes */
  let mapping = {
    Home: <Home />,
    ChangePassword: <ChangePassword />,
    PortalUser: <PortalUser />,
    ClientUser: <ClientUser />,
    ManageRole: <ManageRole />,
    Project: <Project />,
    Milestones: <Milestones />,
    PersonalDetail: <PersonalDetail />,
    TaskDetail: <TaskDetail />,
    Task: <Task />,
    GanttChart: <GanttChart />,
    SerialSequence: <SerialSequence />,
    AddCompany: <AddCompany />,
    AddBusinessUnit: <AddBusinessUnit />,
    AddDepartment: <AddDepartment />,
    BulkUpload: <BulkUpload />,
    ArchiveProjects: <ArchiveProjects />
  };
  return (
    <>
      {loading ? (
        <div className="loader">
          <InfinitySpin width="200" color="#D81159" />
        </div>
      ) : (
        <>
          <ToastContainer />
          <GlobalContext.Provider value={{ roles, rolexModuleData, user_id, serialSequence, userProfile}} >
            <Routes>
              <Route path="/" element={<Layout />}>
                {/* public routes */}
                <Route path="/" index name="prelogin" element={<Login />} />
                <Route path="/register" name="prelogin" element={<Register />} />
                <Route path="/slidebar" name="prelogin" element={<Slidebar />} />
                <Route path="/forgetpassword" name="prelogin" element={<ForgetPassword />} />
                <Route path="/faq" name="prelogin" element={<Faq />} />
                <Route path="/bugs" name="prelogin" element={<Bugs />} />
                <Route path="/sample" name="prelogin" element={<Sample/>} />
               
                {/* <Route path="/unauthorized" name="prelogin" element={<Unauthorized />} /> */}
                {/* <Route path="/error" name="prelogin" element={<ErrorHandle />} /> */}
                <Route path="*" name="prelogin" element={<Unauthorized />} />

                {/* protected routes */}
                {/* {roles && roles.length ? (
                  <Route element={<RequireAuth allowedRoles={[roles?.[0]?.role_id]} />}>
                    {rolexModuleData
                      ? rolexModuleData?.map((data, index) => (
                          <Route key={data?.description} path={data?.description} element={mapping[data?.module]} />
                        ))
                      : null}
                  </Route>
                ) : null} */}

              {rolexModuleData?.map((data) => (
                <Route key={data?.description} path={data?.description} element={mapping[data?.module]} />
              ))}


                {/* catch all */}
                {/* <Route path="*" element={<Missing />} /> */}
              </Route>
            </Routes>
          </GlobalContext.Provider>
        </>
      )}
    </>
  );
}

export default App;
